define.alias("checkout/components/seamless-checkout/review-changes-button", "calendar/components/seamless-checkout/review-changes-button");